import React from "react";

const RatingsCard = ({ ratings }) => {
  if (!ratings) return null;

  return (
    <div className="ratings-card">
      <h3 className="ratings-title">Ratings & Reviews</h3>
      <div className="ratings-summary">
        <div className="rating-box">
          <span className="rating-value">{ratings.average}</span>
          <div className="rating-stars">
            {Array.from({ length: 5 }, (_, i) => (
              <span
                key={i}
                className={`star ${i < Math.round(ratings.average) ? "filled" : ""}`}
              >
                ★
              </span>
            ))}
          </div>
          <span className="review-total">{ratings.totalReviews} Reviews</span>
        </div>

        <div className="ratings-breakdown">
          {[5, 4, 3, 2, 1].map((star) => (
            <div key={star} className="rating-row">
              <span className="star-count">{star}★</span>
              <div className="rating-bar">
                <div
                  className="rating-fill"
                  style={{
                    width: `${(ratings[star] / ratings.totalReviews) * 100}%`,
                  }}
                />
              </div>
              <span className="review-count">{ratings[star]}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RatingsCard;